/**
 * integratedFeatureMeta.js — 통합 메뉴 기능 이름표·회사 표시 색 한 곳 (2026-10-01)
 *
 * 전에는 기능 이름표가 세 파일(통합 메뉴 관리 표·편집 창·메뉴 화면)에 따로 있어 서로 달랐다.
 *   관리 표에는 계약갱신관리·마케터 1:1 관리가 빠져 영어(contract_renewal)가 그대로 보였다.
 *
 * featureKey — 같은 일을 하는 회사별 기능(companyFeatures.js COMPANY_MENU_FEATURES 의 key).
 *   통합 사이드바는 그 기능의 본사 주소(hqPath)를 따라가 분류·아이콘을 정한다 — 분류표를 새로 만들지 않는다.
 * 서버가 받는 종류는 api/services/integrated-menu.service.js ALLOWED_FEATURE_TYPES 와 같다.
 */
export const INTEGRATED_FEATURES = [
  { value: 'leave', label: '연차 관리', featureKey: 'leave' },
  { value: 'attendance', label: '출퇴근 관리', featureKey: 'attendance' },
  { value: 'calendar', label: '출퇴근 달력', featureKey: 'attendance' },
  { value: 'contract_renewal', label: '계약갱신관리', featureKey: 'contractRenewal' },
  { value: 'marketer_consultant', label: '마케터 1:1 관리', featureKey: 'marketer1on1' },
  // 2026-10-13 통합 일일콜(통합 계획 3단계) — 맨 마지막에 둔다(편집 창 목록 순서). 서버 주소·화면은 이미 있다.
  { value: 'tm_call', label: '일일콜현황 관리', featureKey: 'call' },
  // 2026-10-15 통합 계약(통합 계획 4단계 4-5) — 서버 주소는 4-4, 화면은 IntegratedContracts.
  { value: 'contract', label: '계약 관리', featureKey: 'contract' },
  // 2026-10-19 통합 홍보물(통합 계획 5단계 5-6) — 서버 주소는 5-4, 화면은 IntegratedPromotional.
  { value: 'promotional', label: '홍보물 관리', featureKey: 'promotional' },
  // 2026-10-22 통합 미팅지도 — 서버 /admin/integrated-menus/:id/meeting-map, 화면은 미팅지도 관리 한 벌(AdminMeetingMap).
  { value: 'meeting_map', label: '미팅지도 관리', featureKey: 'meetingMap' },
  // 2026-10-29 통합 방문빈도 관리 — 서버 /admin/integrated-menus/:id/region-coverage, 화면은 방문빈도 관리 한 벌(RegionCoverage).
  //   회사별 메뉴가 없는 기능이라 featureKey 대신 hqPath(같은 일을 하는 본사 메뉴 주소)로 사이드바 자리(콜·영업·지도 핀)를 정한다.
  { value: 'region_coverage', label: '방문빈도 관리', hqPath: '/admin/region-coverage' },
];

/** 기능 종류 → 한국어 이름. 모르는 종류는 받은 값 그대로. */
export function integratedFeatureLabel(type) {
  return INTEGRATED_FEATURES.find((f) => f.value === type)?.label || String(type || '');
}

// 회사 표시 색 — 운영사 회사 셋만 고정 색, 그 외 회사(고객 테넌트 등)는 회색.
//   눈으로 회사를 구분하는 표시일 뿐 권한·범위와 무관해서 회사 코드를 적어 둔다(하드코딩 금지 규칙의 예외 사유).
const COMPANY_COLORS = { PINE: '#1d4ed8', DOT: '#ea580c', LNJ: '#15803d' };
const OTHER_COLOR = '#64748b';

export function companyColor(code) {
  return { bg: COMPANY_COLORS[String(code || '').trim().toUpperCase()] || OTHER_COLOR, fg: '#fff' };
}
